// libraries
import React from 'react'

// svg
import { PadLock } from '/react4xp/components/Svg/Others/Icons'

// utils
import { isNonWhitespaceString } from '/lib/reactutils/utils.js'

export interface DocumentationLineProps {
	href: string
	name: string
	date: string
	category: string
	size?: string
	isRestricted?: boolean
}

export default function DocumentationLine({
   href,
   name,
   date,
   category,
   size,
   isRestricted
}: DocumentationLineProps) {
	return (
		<a
			href={href}
			className='documentation-line'
			download={!isRestricted}
		>
			
			<div className='documentation-line__infos'>

				{isNonWhitespaceString(name) && (
					<p className='documentation-line__name'>
						{name}
					</p>
				)}

				<div className='documentation-line__details'>

					{isNonWhitespaceString(date) && (
						<p className='documentation-line__date'>
							{date}
						</p>
					)}

					{isNonWhitespaceString(category) && (
						<p className='documentation-line__category'>
							{category}
						</p>
					)}

					{isNonWhitespaceString(size) && (
						<p className='documentation-line__size'>
							{size}
						</p>
					)}

				</div>

			</div>

			<div className='documentation-line__download'>
				{isRestricted ? (
					<PadLock />
				) : (
					<svg width='16' height='17' viewBox='0 0 16 17' fill='currentColor' xmlns='http://www.w3.org/2000/svg'><path d='M8.89998 0.599976V13.65H7.09998V0.599976H8.89998Z'/><path d='M2.37497 6.47717L7.99997 12.1022L13.625 6.47717L14.8978 7.74997L7.99997 14.6478L1.10217 7.74997L2.37497 6.47717Z'/><path d='M0.224976 14.975H15.775V16.775H0.224976V14.975Z'/></svg>
				)}
				
			</div>

		</a>
	)
}